import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { ListData } from '@rahtab/system/lib/screens/CategoriesList';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { addCategory } from 'rahtab-redux/slices/categoriesSlice';
import { addCategoryInventory, inventoryCategorySelector } from 'rahtab-redux/slices/categoryInventorySlice';
import { useState } from 'react';

export const useCategoryInventory = () => {
  const [idList, setIdList] = useState<Set<string> | undefined>();
  const categories = useSelector(inventoryCategorySelector(Array.from(idList?.values() || [])));
  const dispatch = useAppDispatch();
  const [refetchInventory, { called, loading }] = useFetchCallType<ServerCategoryInventoryItem[]>(
    'GetInventoryProducts',
    {
      onCompleted: (d) => {
        let temp = new Set(idList);
        d.forEach((category) => {
          temp.add(category.ProductCode);
          dispatch(addCategoryInventory(category));
          dispatch(addCategory(category));
        });
        setIdList(temp);
      },
    },
  );

  return {
    refetchInventory,
    loading,
    called,
    data: categories,
  };
};

export interface ServerCategoryInventoryItem {
  ProductCode: string;
  ProductName: string;
  ProductImage: string;
  TemplateCount: string;
  ActiveLoadCount: string;
  StatusCode: '1' | '2';
  Status: string;
}
interface CategoryInventoryItem extends Omit<ListData, 'sellerCount'> {}
